import React, { useEffect } from "react";
import { observer } from "mobx-react";
import CustomRadioButton from "Components/common/customRadioBtn";
import { ReactComponent as LinkedinIcon } from "Assets/svg/linkedin.svg";
import ConstantObj from "Static/constant";
import Button from "Components/common/Button";
import { linkedInTemplatePopupState } from "./LinkedInTemplatePopupState";
import { seqTemplatePopupState } from "./SequenePredefinedTemplate/SeqTemplatePopupState";
import Utils from "Utils/utils";
import { withRouter } from "react-router-dom";

import LinkedInTemplatesListLoading from "./LinkedInTemplatesListLoading";

const LinkedInTemplatesListPopup = observer((props) => {
  const {
    showTemplatesListPopup,
    setShowTemplatesListPopup,
    templates,
    templatesLoader,
    fetchLinkedInTemplates,
    applyLinkedInTemplate,
    applyTemplateLoader,
    selectedTemplate,
    setSelectedTemplate
  } = linkedInTemplatePopupState;

  useEffect(() => {
    if (showTemplatesListPopup) {
      fetchLinkedInTemplates();
    }
  }, [showTemplatesListPopup]);

  if (!showTemplatesListPopup) return null;

  const handleClose = () => {
    if (applyTemplateLoader) return;
    setShowTemplatesListPopup(false);
    seqTemplatePopupState.setAction("");
  };

  const handleBack = () => {
    if (applyTemplateLoader) return;
    if (seqTemplatePopupState?.action === "selectTemplates") {
      seqTemplatePopupState.setSelectedTemplateType("");
      setShowTemplatesListPopup(false);
    } else {
      setShowTemplatesListPopup(false);
      seqTemplatePopupState.setAction("");
    }
  };

  const handleUseTemplate = () => {
    if (selectedTemplate && !applyTemplateLoader) {
      const folderId = Utils.getFolderDetails()?.folderId;
      applyLinkedInTemplate(selectedTemplate.id, folderId, props.history);
    }
  };

  const radioOnchangeAction = (e, id = "") => {
    const template = templates.find(t => (t._id || t.id) === id);
    if (template) {
      setSelectedTemplate(template);
    }
  };

  const renderSteps = () => {
    if (!selectedTemplate) return null;
    const { steps = {} } = selectedTemplate;
    const stepsArray = Object.entries(steps).sort((a, b) => parseInt(a[0]) - parseInt(b[0]));

    return stepsArray.map(([stepNo, stepData], index) => {
      const variant = stepData?.variants ? Object.values(stepData?.variants)[0] : {};
      const type = variant?.linkedInTaskType || "";
      const content = variant?.text || "";
      const daysLater = stepData?.daysLater || 0;
      const stepTitle = ConstantObj.taskSubject[type.toLowerCase()] || type;

      return (
        <div className="stepCard" key={index}>
          <div className="stepHeader">
            <div className="titleGroup">
              <LinkedinIcon className="liIcon" />
              <span className="stepTitle">Step {stepNo} - {stepTitle}</span>
            </div>
            <span className="dayCount">Day {daysLater}</span>
          </div>
          <div className="stepContent">
            {content && <p className="previewText">{content}</p>}
          </div>
        </div>
      );
    });
  };

  return (
    <div className="linkedinTemplatesListPopupSection">
      <div className="card animated customzoomIn">
        <div className="popupHeader">
          <h2 className="title">LinkedIn Sequence Templates</h2>
          <i
            className={`material-icons closeIcon ${applyTemplateLoader ? "disabled" : ""}`}
            onClick={handleClose}
          >
            close
          </i>
        </div>
        <div className="templatesListWrapper">
          <div className="listContainer">
            {templatesLoader ? (
              <LinkedInTemplatesListLoading />
            ) : (
              <div className="templatesContentSplit">
                <div className="templatesListSide">
                  {templates.length > 0 ? (
                    templates.map((template, index) => {
                      const id = template._id || template.id;
                      const isChecked = !!(selectedTemplate && (selectedTemplate._id === id || selectedTemplate.id === id));
                      return (
                        <div
                          key={id || index}
                          className={`templateRadioItem ${isChecked ? "active" : ""}`}
                          onClick={() => setSelectedTemplate(template)}
                        >
                          <CustomRadioButton
                            id={id}
                            value={template.name}
                            name="linkedinTemplate"
                            checked={isChecked}
                            radioOnchange={radioOnchangeAction}
                          />
                        </div>
                      );
                    })
                  ) : (
                    <div className="noTemplates">No templates found</div>
                  )}
                </div>
                <div className="templatePreviewSide">
                  {selectedTemplate ? (
                    <div className="previewScroll">
                      <div className="previewHeader">
                        <h3 className="previewTitle">{selectedTemplate?.name}</h3>
                        {selectedTemplate?.description && (
                          <p className="previewDesc"><strong>Best for:</strong> {selectedTemplate?.description}</p>
                        )}
                        {selectedTemplate?.goal && (
                          <p className="previewGoal"><strong>Goal:</strong> {selectedTemplate?.goal}</p>
                        )}
                      </div>
                      <div className="stepsWrapper">
                        {renderSteps()}
                      </div>
                    </div>
                  ) : (
                    <div className="selectPrompt">Select a template to see preview</div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="popupFooter">
          <button
            className="backBtn"
            onClick={handleBack}
            disabled={applyTemplateLoader}
          >
            Back
          </button>
          <Button
            btnText={linkedInTemplatePopupState?.targetSequenceId ? "Use Template" : "Create and Customize"}
            className={`useTemplateBtn ${applyTemplateLoader ? "loading" : ""}`}
            disabled={!selectedTemplate || templatesLoader || applyTemplateLoader}
            knobs={applyTemplateLoader}
            click={handleUseTemplate}
          />
        </div>
      </div>
      <div className="overlayMaskPopup" onClick={handleClose}></div>
    </div>
  );
});

export { LinkedInTemplatesListPopup };
export default withRouter(LinkedInTemplatesListPopup);
